export const downloadFileFromURL = (inURL: string, inName : string): Boolean => {
    const link = document.createElement("a");
    link.target = "_blank";
    link.download = inName;
    if (!inURL) return false;
    link.href = inURL;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true
}